import logo from './logo.png';
import welcome from './welcome.png';
import timeline from './timeline.png';
import business from './business.png';
import './reset.css';
import './App.css';

function App() {
  return (
    <div className="App">
    <header>
      <div className="logo">
        <img src={logo} alt="logo" />

        <div className="logo__text">
          <h1>Matcher, Tendering Platform</h1>
        </div>
      </div>
    </header>

    <main>
      <div className="welcome">
        <div className="welcome__text">
          <h1>Matching with your business partner via web3</h1>
          <p>
            Matcher platform will provide easy and sustainable web3 applications to match the contractors with the clients.
			 All matching details will be recorded on blockchain and will be avaliable to review later private or public
			  according to the client's preference
          </p>
        </div>

        <div className="welcome__img">
          <img src={welcome} alt="welcome" />
        </div>
      </div>

      <div className="matcher">
        <div className="matcher__text">
          <h1>Easiest way to find your business partners and archive them</h1>
          <p>
            Matcher will serve as a middleman and an insurance company without high fees and complex discussion
          </p>
        </div>

        <div className="matcher__card">
          <div>
            <img src={logo} alt="icon" />
            <h1>Register</h1>
            <p>
              Register your company details as simple as it can
            </p>
			<a href="https://kilopi.net/matcher/" rel="noreferrer" target="_blank">Soon <i className="fa-solid fa-chevron-right"></i></a>
          </div>
          <div>
            <img src={logo} alt="icon" />
            <h1>Match</h1>
            <p>
              Find and match with your business partner
            </p>
            <a href="https://kilopi.net/matcher/" rel="noreferrer" target="_blank">Soon <i className="fa-solid fa-chevron-right"></i></a>
          </div>
          <div>
            <img src={logo} alt="icon" />
            <h1>Audit</h1>
            <p>
              Follow the contracts and partnerships whenever and wherever you like
            </p>
            <a href="https://kilopi.net/matcher/" rel="noreferrer" target="_blank">Soon <i className="fa-solid fa-chevron-right"></i></a>
          </div>
        </div>
      </div>


      <div className="business">
        <div className="business__text">
          <h1>Technology</h1>
          <p>
            Matcher will use blockchain, smart contracts and web3 technologies to provide simple and effective 
			solutions for business partnerships and contract based agreements.
          </p>
        </div>

        <div className="business__img">
          <img src={business} alt="business" />
        </div>
      </div>


     
      <div className="timeline">

    

        <div className="container left-container">

        <img src={timeline} alt="timeline" />

          <div className="text-box">
            <h2>Idea Era</h2>
            <small>2023</small>
            <p> Idea is getting shaped following the meetings and discussions with the Partner companies</p>

              <span className="left-container-arrow"></span>


          </div>

        </div>

      

     

        <div className="container right-container">
          <img src={timeline} alt="timeline" />

          <div className="text-box">
            <h2>Presentation</h2>
            <small>2024</small>
            <p> Teaser Web3 solutions will be released for Companies to make them comfortable</p>

              <span className="right-container-arrow"></span>

          </div>

        </div>

     

     

        <div className="container left-container">
          <img src={timeline} alt="timeline" />

          <div className="text-box">
            <h2>Expand</h2>
            <small>2025</small>
            <p> Applications will be diversified and will be served as professional services with full tokenomics</p>

              <span className="left-container-arrow"></span>


          </div>

        </div>

    
        </div>


        <div className="faq">
          <div className="faq__text">
            <h1>FAQ</h1>
            <div className="line"></div>
          </div>
          <details>
            <summary>What is Matcher ? </summary>
  
            <div>
              Matcher is a platform that serves as a matchmaker for companies to make them find their best partners.
            </div>
          </details>
          <details>
            <summary>Who is behind this idea and development ? </summary>
  
            <div>
              Kilopi team is the founder and the main developer of this platform. More information can be found on kilopi.net website.
            </div>
          </details>
          <details>
            <summary>Which technology is being used for these solutions ? </summary>
  
            <div>
              Blockchain, Smart Contracts, Web3 modules, Html, Css, React, Dom etc. technologies are being used for the solutions.
            </div>
          </details>
          <details>
            <summary>Will there be a fee for using this platform ? </summary>
  
            <div>
              There will be a very small fee to sustain the platform. There will be no profit-based fee.
            </div>
          </details>
          <details>
            <summary>I have another question ! </summary>
  
            <div>
              Please scroll down the page, find social links or email and send a message of your question and the team will be happy to answer.
            </div>
          </details>
        </div>


       

    </main>

    <footer>

      <div className="social">
        <p>2023 Kilopi</p>

        <div className="social__link">
          <ul>
            <li>
              <a href="https://twitter.com/kilopicoin" target="_blank" rel="noreferrer"><i className="fa-brands fa-twitter"></i></a>
            </li>
            <li>
              <a href="https://t.me/tokenkilopi" target="_blank" rel="noreferrer"><i className="fa-brands fa-telegram"></i></a>
            </li>
            <li>
              <a href="https://discord.gg/MQrk5NhWwu" target="_blank" rel="noreferrer" ><i className="fa-brands fa-discord"></i></a>
            </li>

            <li>
              <a href="mailto:info@kilopi.net" target="_blank" rel="noreferrer"><i class="fa-solid fa-envelope"></i></a>
            </li>
          </ul>
        </div>
      </div>
     
    </footer>










    </div>
  );
}

export default App;
